import { findProductPriceHistory, HistoryResult } from '~/Api/Product/PriceHistory';
import { invokeApi, resolve } from '~/ApiClient';
import { ThunkAction } from '~/Store';

import ActionTypes from './ActionTypes';

export function fetchPriceHistory(
	productId: string,
	currency: string | null = null
): ThunkAction<Promise<HistoryResult>, any> {
	return (dispatch) => {
		const request = dispatch(invokeApi(findProductPriceHistory, productId, currency));
		dispatch({ type: ActionTypes.request, request, productId, currency });

		return resolve(request, (response) =>
			dispatch({
				type: ActionTypes.receive,
				request,
				productId,
				currency,
				prices: response?.items,
			})
		);
	};
}

export function pruneAllHistory(): { type: string } {
	return { type: ActionTypes.pruneAll };
}
